<template>
  <div class="form-group">
    <label for="search" class="mr-2">{{ title }}</label>
    <div class="input-icon">
      <i :class="icon" class="text-secondary"></i>
      <input
        :value="modelValue"
        :placeholder="__('equipment.search')"
        :class="inputClass"
        id="search"
        type="search"
        @input="$emit('update:modelValue', $event.target.value)"
        class="input-field"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchBox',
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    inputClass: {
      type: String,
      default: 'form-control'
    },
    icon: {
      type: String,
      default: 'fa-light fa-magnifying-glass icon'
    }
  },
  emits: ['update:modelValue']
}
</script>

<style>
.input-icon i {
  position: absolute;
}

.input-icon {
  width: 100%;
}

.icon {
  padding: 11px 10px 10px 0px;
  min-width: 50px;
  text-align: center;
}

.input-field {
  height: 34px !important;
  padding-left: 35px;
}
</style>
